/**
 * Canonical company identity from the sample report master
 * (`templates/Report Template/WORD/Shams_Environmental_Report_Editable.docx`).
 * Used for org settings defaults, Public Site copy, and PDF fallbacks.
 * Do not invent accreditations or Companies House details not present there.
 */
export const COMPANY = {
  name: "Shams Environmental",
  tagline: "Asbestos surveying and consultancy",
  /**
   * Confirmed by the Owner 2026 — trading as a sole trader, no registered
   * limited company and so no Companies House number to display.
   */
  legalEntity: "Sole trader",
  address: "10 Wraysbury Drive, Basildon, Essex, SS15 4HY",
  phone: "07859739234",
  /** Display form for public site (same number). */
  phoneDisplay: "07859 739234",
  email: "perry.sac1@gmail.com",
  streetAddress: "10 Wraysbury Drive",
  addressLocality: "Basildon",
  addressRegion: "Essex",
  postalCode: "SS15 4HY",
  addressCountry: "GB",
  /**
   * Owner-confirmed 2026-09-23 (ADR-0001 “Surveyor qualifications”).
   */
  qualification: "All surveyors are P402 qualified or equivalent.",
  /**
   * Short positioning — grounded in HSG264 survey types the Owner offers
   * (ADR-0001 “Survey types”), not invented marketing claims.
   */
  positioning:
    "Management and refurbishment & demolition asbestos surveys for UK dutyholders and project teams — HSG264 methodology, clear PDF reports you can act on.",
  description:
    "UK asbestos surveying and consultancy. Management and refurbishment & demolition surveys to HSG264, sampling coordinated with accredited laboratories, and clear PDF reports. All surveyors are P402 qualified or equivalent.",
} as const;

export type CompanyIdentity = typeof COMPANY;
